var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-checkbox',{staticClass:"cc-checkbox",attrs:{"disabled":_vm.disabled,"checked":_vm.value,"indeterminate":_vm.indeterminate,"id":_vm.id},on:{"change":_vm.onCheckboxClick}},[_c('span',[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }